import cx from 'classnames';
import type { FunctionComponent } from 'react';
import { useEffect, useRef, useState } from 'react';

import { boardSwitcherSharedState } from '@trello/board-switcher';
import { useSharedState } from '@trello/shared-state';
import { getTestId, type BoardSwitcherTestIds } from '@trello/test-ids';

import { useBoardSwitcher } from './useBoardSwitcher';
import { WorkspaceTabButton } from './WorkspaceTabButton';
import { WorkspaceTabsMenuButton } from './WorkspaceTabsMenuButton';

import * as styles from './WorkspaceTabs.module.less';

interface WorkspaceTabsProps {
  isPanel?: boolean;
}

export const WorkspaceTabs: FunctionComponent<WorkspaceTabsProps> = ({
  isPanel,
}) => {
  const { workspaces, guestWorkspaceIds } = useBoardSwitcher();
  const [{ selectedWorkspaceId }] = useSharedState(boardSwitcherSharedState);
  const [showDropdown, setShowDropdown] = useState<boolean>(true);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const buttonsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const buttonsWidth = buttonsRef.current?.scrollWidth ?? 0;
    const wrapperWidth = wrapperRef.current?.scrollWidth ?? 0;

    if (buttonsWidth < wrapperWidth) {
      setShowDropdown(false);
    }
  }, []);

  return (
    <div
      className={cx(styles.wrapper, { [styles.panel]: isPanel })}
      ref={wrapperRef}
      data-testid={getTestId<BoardSwitcherTestIds>(
        'board-switcher-workspace-tabs',
      )}
    >
      <div className={styles.buttons} ref={buttonsRef} role="tablist">
        <WorkspaceTabButton
          workspaceId={null}
          isSelected={!selectedWorkspaceId}
        />
        {workspaces.map(({ id }) => (
          <WorkspaceTabButton
            key={id}
            workspaceId={id}
            isSelected={selectedWorkspaceId === id}
          />
        ))}
        {guestWorkspaceIds.map((id) => (
          <WorkspaceTabButton
            key={id}
            workspaceId={id}
            isSelected={selectedWorkspaceId === id}
          />
        ))}
      </div>
      {showDropdown && <WorkspaceTabsMenuButton />}
    </div>
  );
};
